<div class="navigation-menu">
  <nm-button variant="outlined" [fullWidth]="true" (clickButton)="openPage()">Меню</nm-button>
  <nm-button variant="outlined" [fullWidth]="true" (clickButton)="openPage()">Забронировать столик</nm-button>
  <nm-button variant="outlined" [fullWidth]="true" (clickButton)="openTelegram()">Написать в Телеграм</nm-button>
</div>
